export default function PageNotFoundPage(){

    return(
        <>
            <h1>Page Not Found!</h1>
            <p>You should check out what's happening in the leagues above^^</p>
        </>
    )
}